import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import PrivacyPolicy from './privacy';
import Home from './home';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Define your routes */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        {/* Add other routes as needed */}
      <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
        );
        }

        export default App;
      
